import React from "react";
import { Helmet } from "react-helmet";
import { useAppCurrentVersion } from "../AppCurrentVersionProvider";
import { useAppOrgsAndInvitedOrgs } from "../AppOrgsAndInvitedOrgsProvider";

const SERVICE_TITLE = "OPTIUM";
const COMPANY_TITLE = "ALGO ARTIS";

export const AppHead: React.FC = () => {
  const { version } = useAppCurrentVersion();
  const { pageTitle } = useAppOrgsAndInvitedOrgs();

  return (
    <Helmet>
      <title>
        {pageTitle !== null
          ? `${pageTitle}${
              version ? ` (${version.title})` : ""
            } - ${SERVICE_TITLE}`
          : `${COMPANY_TITLE} ${SERVICE_TITLE}`}
      </title>
    </Helmet>
  );
};
